module.exports = __webpack_public_path__ + "static/media/Teal_Potter.265ec4fa.jpg";